import RegistrationStatusSection from './RegistrationStatusSection';
import { RegistrationStatusSectionProps, RegistrationStatusSectionValueProps } from './types';

export type { RegistrationStatusSectionProps, RegistrationStatusSectionValueProps };
export default RegistrationStatusSection;
